import {createSelector} from "reselect";
import {getBaseArticle} from "./SimpleSelectors";
import {cmsArticles, shopArticles} from "../config/Config";
import {_initialSoftware} from "./GetParam";
import {getArticleOptionsInCartList} from "./CartUtil";
import {getFormValues} from "redux-form";
import {ARTICLE_TYPE_CMS, ARTICLE_TYPE_SHOP} from "../constants/General";

// **************************************************************************************************************
export const getSoftwareData = (state) => state.software && state.software.softwareData
export const getSoftwareOrder = (state) => state.software && state.software.softwareOrder

export const getSoftwareOptions = createSelector(
    [getSoftwareData, getSoftwareOrder, getBaseArticle, getArticleOptionsInCartList, getFormValues('projectSelection')],
    (softwareData, softwareOrder, baseArticleData, articleOptionsList, projectSelectionFormValues) => {

        if (!softwareOrder || !softwareData) {
            return []
        }

        // check base article number and article options
        const articleNumbersToCheck = ["" + baseArticleData.articleNumber, ...articleOptionsList];

        let softwareMode = 1; // default

        if (projectSelectionFormValues) {
           if (projectSelectionFormValues.type === ARTICLE_TYPE_CMS) {
               softwareMode = 2;
           }  else if (projectSelectionFormValues.type === ARTICLE_TYPE_SHOP) {
               softwareMode = 3;
           }
        }

        if (cmsArticles.some((element) => articleNumbersToCheck.includes("" + element))) {
            softwareMode = 2; // only non-shop
        } else if (shopArticles.some((element) => articleNumbersToCheck.includes("" + element))) {
            softwareMode = 3; // only shop
        }

        let softwareArray = softwareOrder.map(key => {
            const softwareObject = {
                value: key,
                isDefault: false,
                display: {
                    title: softwareData[key].name,
                    icon: `images/software/${key}.svg`
                }
            }

            // also include initial software in list
            if (softwareMode === 1 || key === _initialSoftware) {
                return softwareObject;
            } else if (softwareMode === 2) {
                if (softwareData[key].category.uid !== 19) {
                    return softwareObject
                }
            } else if (softwareMode === 3) {
                if (softwareData[key].category.uid === 19) {
                    return softwareObject
                }
            }
            return null;
        }).filter(elem => elem);

        softwareArray.unshift({
            value: "",
            isDefault: true,
            display: {
                title: "Ohne CMS- / Shop-Installation",
                icon: ``
            }
        })

        return softwareArray
    }
)



/** WEBPACK FOOTER **
 ** ./src/selectors/Software.js
 **/